import { PayMode } from '../../Shared/invoice-enum'
import { BaseEntity } from '../BaseEntity';
import { PendingInvoice } from '../PendingInvoice';
import { PaymentDetail } from './PaymentDetail';
import { User } from './User';
export class MemberInvoice extends BaseEntity {
  InvoiceId: number;
  InvoiceNumber: number;
  InvoiceCode: number;
  InvoiceDate: Date;
  DiscountPerc: number;
  DiscountAmt: number;
  PaidBy: PayMode;
  RecipientID: number;
  PreviousInvoices: PendingInvoice;
  TotalPreviousBalance: number;
  TotalAmount: number;
  BalanceAmount: number;
  PaidAmount: number;
  TotalAmountWithoutGST: number;
  TotalCGSTAmount: number;
  TotalSGSTAmount: number;
  NetTotal: number;
  InvoiceDiscount: number;
  PreparedByUser: User;
  TotalTaxAmount: number;
  TotalIGSTAmount: number;
  IsDiscountEdited: number;
  IsGstIncludedInPrice: boolean;
  PaymentDetails: PaymentDetail[];
  Remarks: string;
  NextPaymentDate: Date;
}
